import { EMAIL_REGEX } from './regex';

export const isIncorrectEmail = (email: string): boolean => {
  if (!email.match(EMAIL_REGEX)) {
    return true;
  }

  return false;
};
